import { useTranslation } from 'react-i18next';
import { Users, ShoppingBag, Truck, Star } from 'lucide-react';

export function StatisticsSection() {
  const { t } = useTranslation();
  
  const stats = [
    {
      id: 1,
      name: t('home.stats.users'),
      value: '10,000+',
      icon: Users,
      color: 'bg-blue-100 text-blue-600'
    },
    {
      id: 2,
      name: t('home.stats.products'),
      value: '25,000+',
      icon: ShoppingBag,
      color: 'bg-green-100 text-green-600'
    },
    {
      id: 3,
      name: t('home.stats.deliveries'),
      value: '50,000+',
      icon: Truck,
      color: 'bg-purple-100 text-purple-600'
    },
    {
      id: 4,
      name: t('home.stats.satisfaction'),
      value: '4.8/5',
      icon: Star,
      color: 'bg-yellow-100 text-yellow-600'
    }
  ];
  
  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            {t('home.stats.title')}
          </h2>
          <p className="mt-4 text-lg text-gray-500">
            {t('home.stats.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((stat) => {
            const IconComponent = stat.icon;
            return (
              <div key={stat.id} className="bg-white overflow-hidden shadow rounded-lg border border-gray-200">
                <div className="px-4 py-5 sm:p-6">
                  <div className="flex items-center">
                    <div className={`flex-shrink-0 rounded-md p-3 ${stat.color}`}>
                      <IconComponent className="h-6 w-6" />
                    </div>
                    <div className="ml-5 w-0 flex-1">
                      <dl>
                        <dt className="text-sm font-medium text-gray-500 truncate">
                          {stat.name}
                        </dt>
                        <dd className="text-3xl font-semibold text-gray-900">
                          {stat.value}
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}